export enum SiteTypeEnum{
  PROFFWEB = "PROFFWEB",
  AHP = "AHP"
}